import { communicationKeys } from './communicationKeys';

export interface IBankNotesKeyParams {
  applicationID: string | undefined;
  marketCountry: string | undefined;
  communicationItemID?: string;
}

export const bankNotesKeys = {
  root: (params: IBankNotesKeyParams) =>
    [
      ...communicationKeys.root(params),
      'bank notes',
      params.marketCountry,
    ] as const,
};

export function parseBankNotesKey<T extends keyof typeof bankNotesKeys>(
  queryKey: ReturnType<(typeof bankNotesKeys)[T]>
) {
  const [, applicationID, , marketCountry] = queryKey;
  return { applicationID, marketCountry };
}
